import Legend from "./Legend";

export default Legend;
export * from "./legendRedux";
